import React, { useState } from "react";
import {
    Select,
    Checkbox,
    Row,
    Col,
    Button,
    Space,
    DatePicker,
    Dropdown,
    Modal,
    Image,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { DownOutlined } from "@ant-design/icons";
import SOSLogReportStore from "../store/SOSLogReportStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "js-cookie";
import MapForVehiclePosition from "./MapForVehiclePosition";

const { RangePicker } = DatePicker;
const { Option } = Select;
class SOSLogReportList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.SOSLogStore = new SOSLogReportStore();
        this.vehicleStore = new VehicleStore();

        this.state = {
            loading: false,
            pageSize: 50,
            pageNo: 1,
            offset: 0,
            limit: 50,
            currentPage: 1,
            companyId: "",
            modalVisible: false,
            column: "",
            filter: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            showMonthPopup: false,
            Notcompany: false,
            page: "",
            heading: "",
            vehicleObj: false,

            selectedColumns: [
                {
                    title: context.translate("_COMPANY_NAME_"),
                    dataIndex: "companyName",
                    // fixed: 'left',
                    width: "15%",
                    key: "companyName",
                },
                {
                    title: context.translate("_VEHICLE_NO_"),
                    dataIndex: "vehicleNo",
                    width: "15%",
                    key: "vehicleNo",
                },
                {
                    title: context.translate("_FLEET_REPORTS_DATE_"),
                    dataIndex: "dateTime",
                    key: "dateTime",
                    width: "15%",
                    render: (value) => {
                        const formattedDateTime = dayjs(value).format(
                            "DD-MM-YYYY hh:mm:ss A"
                        );
                        return <>{formattedDateTime}</>;
                    },
                },
                {
                    title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
                    dataIndex: "location",
                    key: "location",
                    width: "15%",
                },
                {
                    title: context.translate("_FLEET_DASHBORD_SETTING_LATITUDE_"),
                    dataIndex: "latitude",
                    key: "latitude",
                    width: "15%",
                },
                {
                    title: context.translate("_FLEET_DASHBORD_SETTING_LONGITUDE_"),
                    dataIndex: "longitude",
                    key: "longitude",
                    width: "15%",
                },
                {
                    title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
                    //   dataIndex: "GPS",
                    //   key: "GPS",
                    width: "15%",
                    render: (value, obj) => {
                        return (
                            <>
                                <Image
                                    src={require("../assets/images/mapIcon/gps_icon.png")}
                                    width={25}
                                    height={25}
                                    onClick={async () => {
                                        await this.setState({
                                            vehicleObj: { ...obj, icon: "map-car-icon-green.png" },
                                            heading: "SOS Log Report Map",
                                        });
                                        await this.setState({ loadData: 1 });
                                    }}
                                />
                            </>
                        );
                    },
                },
            ],
        };
        this.menuProps = {
            items: [
                {
                    label: context.translate("_EXCEL_"),
                    key: "excel",
                },
                {
                    label: context.translate("_PDF_"),
                    key: "pdf",
                },
            ],
            onClick: (val) => {
                let result = [];
                console.log(val);
                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    //  console.log(result.toString())

                    var getData = {
                        companyId: this.state.companyId,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        userId: 1,
                        filter: this.state.filter,

                        colList: result.toString(),
                    };
                    if (val.key == "excel") {
                        // console.log("afd")
                        this.SOSLogStore.exportExcel(getData);
                    }
                    if (val.key == "pdf") {
                        this.SOSLogStore.exportpdf(getData);
                    }

                }
            },
        };
        this.newColumns = [...this.state.selectedColumns];
    }
    async componentDidMount() {

        this.setState({ pageSize: 50 });

        await this.setState({ column: this.state.selectedColumns });
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.vehicleObj !== prevState.vehicleObj) {
            setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
            }, 10);
        }
    }
    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ companyId: comp?.value });
        await this.setState({ loadData: 1 });
    }

    async handleSearch() {
        // this.setState({ loading: true });
        this.setState({ Notasset: false });
        await this.SOSLogStore.loadData({
            offset: (this.state.pageNo - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
            pageNo: this.state.pageNo,
        });

        await this.setState({ loadData: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        console.log(pagination);
        await this.setState({
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.showData();
    }



    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }

        if (this.state.companyId) {
            // this.setState({mandatory:false})
            this.setState({ Notcompany: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.SOSLogStore.loadData({
                    offset: (this.state.pageNo - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    pageNo: this.state.pageNo,
                });
            }
        }
        this.setState({ loadData: 1 })
    };

    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
        }
    };

    addMonths = (date, months) => {
        var indx = dayjs().month() + -6;
        return dayjs().month(indx);
    };

    checkFromDate(dates) {
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }

    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss,";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        }
    };

    render() {
        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed">
                        <Col span={12}>
                            <div className="heading">
                                {this.context.translate("_SOS_LOG_REPORT_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >


                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>

                                <Dropdown
                                    menu={this.menuProps}
                                    disabled={
                                        this.SOSLogStore?.soslogRport?.length > 0 ? false : true
                                    }
                                >
                                    <Button className="exportDropdown"
                                    >
                                        <Space>
                                            {/* Export */}
                                            {this.context.translate("_EXPORT_")}
                                            <DownOutlined />
                                        </Space>
                                    </Button>
                                </Dropdown>
                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                <CompanyAutocomplete
                                    allowClear={true}
                                    onChange={this.handleChange}
                                    style={{ width: 150 }}
                                    status={this.state.Notcompany ? "error" : false}
                                />

                                <RangePicker
                                    placeholder={["From Datetime", "To Datetime"]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400 }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    // disabledDate={(current) => {
                                    //     return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [dayjs().startOf("day"), dayjs()],
                                    }}
                                    defaultValue={[dayjs().startOf("day"), dayjs()]}
                                />
                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ pageNo: 1, pageSize: 50 });
                                        await this.showData();

                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                            </Space>
                        </Col>
                        <Col span={4}>
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            ></Space>
                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {console.log(this.newColumns, "Df")}
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.pageNo}
                        pageSize={this.state.pageSize}
                        total={this.SOSLogStore?.total}
                        columns={this.state.column}
                        dataSource={this.SOSLogStore?.soslogRport}
                        loading={this.SOSLogStore?.loading}
                        onChange={this.handleTableChange}

                    />
                    {this.state.vehicleObj && (
                        <MapForVehiclePosition
                            vehicleObj={this.state.vehicleObj}
                            heading={this.state.heading}
                            closeMapModal={(resp) => {
                                this.setState({ vehicleObj: resp });
                            }}
                        />
                    )}


                    <Modal
                        width={350}
                        className="alert-model"
                        title={
                            <div>
                                {" "}
                                <i
                                    style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                    class="bi bi-exclamation-triangle"
                                ></i>{" "}
                                {/* Alert */}
                                {this.context.translate("_FLEET_ALERT_")}
                            </div>
                        }
                        open={this.state.showMonthPopup}
                        onOk={() => this.setState({ showMonthPopup: false })}
                        onCancel={() => this.setState({ showMonthPopup: false })}
                        footer={false}
                    >
                        {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                    </Modal>
                </div>
            </>
        );
    }
}
SOSLogReportList.contextType = StoreContext;
export default observer(withRouter(SOSLogReportList));
